<template>
    <div class="card mb-5 mb-xxl-8" v-show="!isReady">
      <div class="card-body pb-0">
        <div class="card-header flex-wrap border-0 pt-6 pb-0">
          <div class="card-title">
            <h3 class="card-label">{{ $t('store.entrie.unvalid_title') }}</h3>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <table class="table align-middle table-row-bordered fs-6 gy-3 " id="kt_datatable_unvalid_entry">
                <thead>
                <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                    <th class="min-w-100px">{{ $t('store.entrie.numero') }}</th>
                    <th class="min-w-100px">{{ $t('store.entrie.date') }}</th>
                    <th class="min-w-100px">{{ $t('store.expeditor') }}</th>
                    <th class="min-w-100px">{{ $t('store.entrie.entry_status') }}</th>
                    <th class="min-w-100px">{{ $t('action') }}</th>
                </tr>
                </thead>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="container-xxl" v-show="isReady">
      <Loader />
    </div>
</template>

  <script>
  import {mapActions} from "vuex";
  import {BASE_URL} from "@/services/api";
  import Loader from "@/components/Loader.vue";

  export default {
    name: "UnvalidEntry",
    components: { Loader },
    data(){
      return{
        isLoading: false,
        store: {},
        isReady: false
      }
  
    },

    async mounted(){
      this.isReady = true
  
      this.fetchDatas();

      let response = await this.showStore(this.$route.params.id)
      this.store = response.data.store

      $(document).on('click', '#kt_datatable_unvalid_entry .detail_btn', (e) => {
        if(this.store.etat == 'active'){
          let id = e.target.getAttribute('data-id')
          this.$router.push({ name: 'store-unvalid-entry-view', params: { entry_id: id } })
        }
      }),

      $(document).on('click', '#kt_datatable_unvalid_entry .validate_btn', (e) => {
        if(this.store.etat == 'active'){
          let id = e.target.getAttribute('data-id')
          Swal.fire({
            text: i18n.global.t('store.validate_entry_msg'),
            icon: "success",
            showCancelButton: true,
            confirmButtonText: i18n.global.t('store.confirm'),
            cancelButtonText: i18n.global.t('store.cancel'),
            customClass: {
                confirmButton: "btn btn-success",
                cancelButton: 'btn btn-secondary'
            }
          }).then((result) => {
            if (result.isConfirmed) {
                this.validate(id);
            }
          })
        } 
      })
      
      this.isReady = false
    },

    methods: {  
      ...mapActions('store',[
        'validateEntryInStore',
        'showStore'
      ]),

      fetchDatas() {
          const AUTH_TOKEN = Ls.get('auth.token')

          this.table = $("#kt_datatable_unvalid_entry").DataTable({
              responsive: !0,
              searchDelay: 500,
              processing: !0,
              serverSide: !0,
              pageLength: Ls.get('pageLength') ?? 10,
              lengthMenu: [5, 10, 25, 50, 75, 100 ],
              order: [[ 1, 'asc']],
              ajax: {
              url: BASE_URL + "/get/stores/" + this.$route.params.id + "/unvalide/entries",
              type: "GET",
              beforeSend: function (request) {
                  request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
              },
              data: function (d) {
              },
              },
              columns: [{ data: "numero" }, { data: "date" }, { data: "expeditor" }, { data: "valide" }, { data: "Actions", responsivePriority: -1 }],

              columnDefs: [
              {
                  targets: -5,
                  order: "desc",
                  className: "dt-center clickable",
                  render: function (t, a, e, l) {
                  return '<span data-id="' + e.id + '" class="numRow' + l.row + '">' + t + "</span>";
                  },
              },
              {
                  targets: -4,
                  order: "desc",
                  className: "dt-center clickable",
                  render: (t, a, e, l) => {
                  return '<span data-id="' + e.id + '"  class="dateRow' + l.row + '">' + t + "</span>";
                  },
              },
              {
                  targets: -3,
                  order: "desc",
                  className: "dt-center clickable",
                  render: (t, a, e, l) => {
                  return '<span data-id="' + e.id + '"  class="dateRow' + l.row + '">' + t + "</span>";
                  },
              },
              {
                  targets: -2,
                  order: "desc",
                  className: "dt-center clickable",
                  render: (t, a, e, l) => {
                      if (e.valide == true) {
                          return '<span data-id="' + e.id + '"  class="text-success statusRow' + l.row + '">' + i18n.global.t('store.valide') + "</span>";
                      } else {
                          return '<span data-id="' + e.id + '"  class="text-danger statusRow' + l.row + '">' + i18n.global.t('store.unvalide') + "</span>";
                      }
                  },
              },

              {
                  width: "10%",
                  targets: -1,
                  "className": "dt-center",
                  title: "Actions",
                  orderable: !1,
                  render: (t, a, e, l) => {
                      let render = ""
                      if(this.$can('no_validate_entry_view')  ){
                        render+='<button type="button" data-row="'+ l.row +'" data-id="'+ e.id +'" class="btn btn-sm btn-light-primary detail_btn"> Valider </button>'
                      }
                      
                      return render
                  },
              },
              ],
              language: {
              url: this.$i18n?.locale == 'fr' ? "//cdn.datatables.net/plug-ins/1.10.20/i18n/French.json" : "//cdn.datatables.net/plug-ins/1.10.20/i18n/English.json" ,
              }
          });
      },

      async validate(id){
        this.isLoading = true
        
        try{
          await this.validateEntryInStore(id)
          window.toastr['success'](i18n.global.t("notification.shop_validate_entry"))
          this.fetchDatas();
          this.isLoading = false
          return true
        }catch(err){
          this.isLoading = false;
        }
      }
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  